module.exports = __webpack_public_path__ + "images/7c4a06ad58980a0eb960bbeb31cca0d5.svg";